import React, { useEffect, useState } from 'react';
import './style.css';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import http from '../../services/http-service'
// import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import ButtonGroup from '@mui/material/ButtonGroup';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';


function Notifications({employerCodeForNotification}) {
    const history = useHistory();
    // const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem('loginUser')))
    const [tableData, setTableData] = useState([])
    const [userDetails, setUserDetails] = useState([])
    const [openSpinner, setOpenSpinner] = useState(false);

    const handleSpinnerClose = () => {
        setOpenSpinner(false);
    };
    const handleSpinnerToggle = () => {
        setOpenSpinner(!openSpinner);
    };

    useEffect(() => {
        getNotificationData()
        // eslint-disable-next-line
    }, []);

    const getNotificationData = () => {
        console.log('employedCode....',employerCodeForNotification)
        let params = {
            "employer_code": employerCodeForNotification
        }
        handleSpinnerToggle()
        http('employer/new_enrollment_registration/', 'GET', '', params)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    setTableData(res.data)
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId1"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const handleChangeStatus = (mainIndex, fieldIndex, event) => {
        if (event.target.value === 'correct') {
            tableData[mainIndex].user_details[fieldIndex].correct = event.target.checked
            tableData[mainIndex].user_details[fieldIndex].incorrect = !event.target.checked
        }
        else {
            tableData[mainIndex].user_details[fieldIndex].correct = !event.target.checked
            tableData[mainIndex].user_details[fieldIndex].incorrect = event.target.checked
        }
        setUserDetails(tableData[mainIndex].user_details.map((obj, i) => i === fieldIndex ? tableData[mainIndex].user_details[fieldIndex] : obj))
    }

    const submitData = () => {
        let filterArr = []
        tableData.forEach(element => {
            let filterData = element.user_details.find(obj => {
                return !obj.correct && !obj.incorrect
            })
            if (!filterData)
                filterArr.push(element)
        })
        if (filterArr.length === 0){
            toast.error('Please check atleast one record!',{
                toastId: "toastId2"
              })
            return;
        }

        handleSpinnerToggle()
        http('employer/new_enrollment_registration/', 'POST', filterArr)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    // setTableData(res.data)
                    toast.success(res.message,{
                        toastId: "toastId3"
                      })
                    getNotificationData()
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId4"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const handleCancel = () =>{
        history.goBack();
    }
    return (
        <div className=''>
            <ToastContainer />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openSpinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <Typography variant="h2" component="h2" className='settingTabHeading'>
                    New Enrollment Registeration
                </Typography>
                <Typography variant="h6" component="h6" className='settingverifyTxt'>
                    Verify each employee record against company records; Then submit the form
                </Typography>

                {
                    tableData.length > 0 ? (
                        <div>
                            <div className='enrollTabDiv'>
                                {
                                    tableData.map((item, index) => (
                                        <Accordion>
                                            <AccordionSummary className='accordianHeading'
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography key={item.name}>{item.name}</Typography>
                                            </AccordionSummary>

                                            <AccordionDetails className='accordianDescription'>
                                                {
                                                    item.user_details.map((field, idx) => (
                                                        <Grid container mt={1} className='recordTabRow'>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                {/* <Checkbox defaultChecked />  */}
                                                                {field.name}
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <TextField key={field.value + idx} inputProps={{ disabled: true }} id="outlined-basic" variant="outlined" value={field.value} className='enrollTxtField' />
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={4}>
                                                                <FormControl>
                                                                    <RadioGroup key={'radiogrp' + index + idx} className='displayradiobuttons'
                                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                                        name="radio-buttons-group"
                                                                    >
                                                                        <FormControlLabel value='correct' control={<Radio />} label="Correct" checked={field.correct === true}
                                                                            onClick={(e) => {
                                                                                handleChangeStatus(index, idx, e)
                                                                            }} />
                                                                        <FormControlLabel value='incorrect' control={<Radio />} label="Incorrect" checked={field.incorrect === true}
                                                                            onClick={(e) => {
                                                                                handleChangeStatus(index, idx, e)
                                                                            }}
                                                                        />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    ))
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                    ))
                                }
                            </div>
                            <ButtonGroup aria-label=" button group" className='gridbtnSubmit'>
                                <button className='btnSubmit' onClick={submitData}>Submit</button>
                                <button className='btnSubmit btnCancel' onClick={handleCancel}>Cancel</button>
                            </ButtonGroup>
                        </div>
                    ) : (
                        <div className='recordNotFoundDiv'>
                            <h2>Records Not Found</h2>
                        </div >
                    )
                }
            </Box>
        </div>
    );
}

export default Notifications;